module.exports = __webpack_public_path__ + "static/media/checkoutHero.9281a179.png";